import { render, staticRenderFns } from "./FRadio.vue?vue&type=template&id=416b80e9&scoped=true&"
import script from "./FRadio.vue?vue&type=script&lang=js&"
export * from "./FRadio.vue?vue&type=script&lang=js&"
import style0 from "./FRadio.vue?vue&type=style&index=0&id=416b80e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b80e9",
  null
  
)

export default component.exports